import * as React from "react";
import { CircularProgress } from "@material-ui/core";

export default class Loader extends React.PureComponent<{ style?: React.CSSProperties, size?: number, white?: boolean }> {
    public render() {
        return <div style={{
            width: '100%', ...this.props.style, zIndex: 10,
            display: 'flex', justifyContent: 'center',
            color: this.props.white ? 'white' : 'var(--platform)'
        }}>
            <CircularProgress color={'inherit'} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Loader.tsx